var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResourcesPageBannerW1920Px(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 300,
    fill: "url(#paint0_linear_10771_16449)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1601.3 222.034C1606.29 222.034 1606.29 214.283 1601.3 214.283C1596.32 214.283 1596.32 222.034 1601.3 222.034Z",
    fill: "#A3EA2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1498.88 160.876C1501.39 160.876 1501.39 157 1498.88 157C1496.37 157 1496.37 160.876 1498.88 160.876Z",
    fill: "#A3EA2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.57 257.509C1555.08 257.509 1555.08 253.633 1552.57 253.633C1550.07 253.633 1550.07 257.509 1552.57 257.509Z",
    fill: "#A3EA2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M568.74 209.751C573.727 209.751 573.727 202 568.74 202C563.753 202 563.753 209.751 568.74 209.751Z",
    fill: "#A3EA2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M442.68 89.7512C447.666 89.7512 447.666 81.9998 442.68 81.9998C437.693 81.9998 437.693 89.7512 442.68 89.7512Z",
    fill: "#A3EA2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M384.88 151.405C387.386 151.405 387.386 147.529 384.88 147.529C382.373 147.529 382.373 151.405 384.88 151.405Z",
    fill: "#A3EA2A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M457.355 256.1C459.861 256.1 459.861 252.224 457.355 252.224C454.849 252.224 454.849 256.1 457.355 256.1Z",
    fill: "#A3EA2A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10771_16449",
    x1: 813.961,
    y1: -145.2,
    x2: 939.915,
    y2: 538.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#182337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#151C2B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesPageBannerW1920Px);
export default __webpack_public_path__ + "static/media/resources-page-banner-w1920px.3f4f054a81f90c21e4410207a4fa2d94.svg";
export { ForwardRef as ReactComponent };